import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ImportDialogData } from './import-dialog-data.token';

@Injectable({ providedIn: 'root' })
export class ImportDialogDataService {
  private dataSubject = new BehaviorSubject<ImportDialogData | null>(null);
  data$ = this.dataSubject.asObservable();

  setData(data: ImportDialogData) {
    this.dataSubject.next(data);
  }

  clearData() {
    this.dataSubject.next(null);
  }

  getData(): ImportDialogData | null {
    return this.dataSubject.getValue();
  }
}
